import { render, staticRenderFns } from "./collect-detail-single-modal.vue?vue&type=template&id=ca6d927a&scoped=true&"
import script from "./collect-detail-single-modal.vue?vue&type=script&lang=js&"
export * from "./collect-detail-single-modal.vue?vue&type=script&lang=js&"
import style0 from "./collect-detail-single-modal.vue?vue&type=style&index=0&id=ca6d927a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6d927a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})


/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca6d927a')) {
      api.createRecord('ca6d927a', component.options)
    } else {
      api.reload('ca6d927a', component.options)
    }
    module.hot.accept("./collect-detail-single-modal.vue?vue&type=template&id=ca6d927a&scoped=true&", function () {
      api.rerender('ca6d927a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/collect-detail-single-modal.vue"
export default component.exports